import moment from 'moment'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { useFinancialWorkspace } from '../../../Providers/Provider'
import { HeaderData } from '../../../types/table'

export const useComparisonHeaders = (): HeaderData[] | undefined => {
  const {
    hasComparisonDate,
    formattedState: { formattedStartDate, formattedEndDate },
  } = useFinancialWorkspace()

  return useUnsafeMemo(() => {
    if (!hasComparisonDate) return undefined

    const headers: HeaderData[] = []
    const start = moment(formattedStartDate)
    const end = moment(formattedEndDate)

    const monthDiff = end.diff(start, 'months') + 1

    if (monthDiff <= 1) return undefined

    Array.from({ length: monthDiff }, (_, i) => {
      const date = moment(start).add(i, 'months')

      headers.push({
        value: date,
        label: date.format('MMMM'),
      })
    })

    return headers
  }, [formattedEndDate, hasComparisonDate, formattedStartDate])
}
